if (!customElements.get('content-card-carousel')) {
  customElements.define('content-card-carousel', class ContentCardCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.track = this.querySelector('[data-content-card-track]');
      this.previousButton = this.querySelector('[data-content-card-previous]');
      this.nextButton = this.querySelector('[data-content-card-next]');

      if (!this.track || !this.previousButton || !this.nextButton) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.previousButton.addEventListener('click', () => this.scrollByCard(-1), { signal });
      this.nextButton.addEventListener('click', () => this.scrollByCard(1), { signal });
      this.track.addEventListener('scroll', () => this.queueControlsUpdate(), { passive: true, signal });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.queueControlsUpdate());
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.queueControlsUpdate(), { signal });
      }

      this.queueControlsUpdate();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.updateFrame);

      this.abortController = null;
      this.resizeObserver = null;
    }

    scrollByCard(direction) {
      const item = this.track.querySelector('[data-content-card-item]');
      if (!item) return;

      const trackStyles = getComputedStyle(this.track);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      const directionFactor = trackStyles.direction === 'rtl' ? -1 : 1;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollBy({
        left: (item.getBoundingClientRect().width + gap) * direction * directionFactor,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    }

    queueControlsUpdate() {
      cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.updateControls());
    }

    updateControls() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrollPosition = Math.abs(this.track.scrollLeft);
      const hasOverflow = maxScroll > 2;

      this.previousButton.hidden = !hasOverflow || scrollPosition <= 2;
      this.nextButton.hidden = !hasOverflow || scrollPosition >= maxScroll - 2;
    }
  });
}
